import apiClient from './client';
import { API_ROUTES } from './routes';

export interface User {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: string | null;
  avatar: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateProfileRequest {
  firstName?: string | null;
  lastName?: string | null;
  dateOfBirth?: string | null;
  avatar?: string | null;
}

export const userApi = {
  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>(API_ROUTES.USERS.ME);
    return response.data;
  },

  updateProfile: async (data: UpdateProfileRequest): Promise<User> => {
    const response = await apiClient.patch<User>(API_ROUTES.PROFILE.UPDATE, data);
    return response.data;
  },
};
